import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { Biller } from "../models/users/billers/billerDto";
import { Collector } from "../models/users/collectors/collectorDto";
import { Employee } from "../models/profile/employee";

@Injectable({
  providedIn: "root",
})
export class BillerCollectorService {
  private userManagementBaseURL = environment.baseUrl + "/User";
  private commonBaseURL = environment.baseUrl + "/Common";

  constructor(private _http: HttpClient) {}

  getAllBiller(): Observable<GenericResponseDto<Biller[]>> {
    return this._http.get<GenericResponseDto<Biller[]>>(
      this.userManagementBaseURL + `/GetAllBillers`
    );
  }

  getAllCollector(): Observable<GenericResponseDto<Collector[]>> {
    return this._http.get<GenericResponseDto<Collector[]>>(
      this.userManagementBaseURL + `/GetAllCollectors`
    );
  }

  createEditBiller(payload: Biller): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.userManagementBaseURL + "/AddOrUpdateBillerInformation",
      payload
    );
  }

  createEditCollector(
    payload: Collector
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.userManagementBaseURL + "/AddOrUpdateCollectorInformation",
      payload
    );
  }

  GetUserByPersonnelNumber(
    //personnelNumber = '',
    userType = ""
  ): Observable<GenericResponseDto<Employee[]>> {
    return this._http.get<GenericResponseDto<Employee[]>>(
      this.commonBaseURL +
        `/UnusedPersonnelNumbersBillerAndCollector?userType=${userType}`
    );
  }
}
